<template>
    <div>
        <h1>{{msg}}</h1>
        <button @click="getDevices">Get list of devices</button>
        <div v-if="devices">
            <li v-for="device in devices" :key="device.serial" >
            <span v-text="device.name"></span>
            </li>
        </div>
        <p v-if="error_message.length">
            <span v-text="error_message"></span>
        </p>
    </div>
</template>

<script>
import {HTTP} from '../http-constants'
export default {
  name: 'ShowDevices',
  data () {
    return {
      devices: '',
      error_message: "",
      msg:''
    }
  },
  methods: {
    getDevices: function () {
      var self = this;
      HTTP.get('/devices/?type=tracker')
        .then(response => {
          self.devices = response.data;
        })
        .catch(e => {
          var message = e.message;
          self.error_message = message;
          self.devices = [];
        })
    }
  },
  mounted: function(){
    this.getDevices();
  }
}
</script>